import { AUDIENCES, T, type AudienceKey } from './copy'
import { MicrosoftMark, PrimaryButton, ThresholdCanvas } from './primitives'

interface SignInScreenProps {
  audience: AudienceKey
  onSignIn: () => void
  ctaTestId?: string
}

/**
 * Screen 1 — the sign-in threshold (arrival). Eyebrow, display title, and a
 * single Microsoft primary action, staggered in on mount. Copy is
 * parameterized by audience; the CTA is auto-focused for keyboard-first use.
 *
 * @param audience - Which role audience's copy to show ('admin' | 'consultant').
 * @param onSignIn - Invoked when the CTA is activated (wired to MSAL login()).
 * @param ctaTestId - data-testid for the CTA. Defaults to 'login-button'.
 * @returns The sign-in threshold screen.
 */
export function SignInScreen({ audience, onSignIn, ctaTestId = 'login-button' }: SignInScreenProps) {
  const a = AUDIENCES[audience]
  return (
    <ThresholdCanvas>
      <div style={{ maxWidth: '20ch' }}>
        <p className="rise" style={{ ...T.eyebrow, animationDelay: '350ms' }}>
          {a.eyebrow}
        </p>
        <h1 className="rise" style={{ ...T.display, marginTop: 22, animationDelay: '500ms' }}>
          {a.title}
        </h1>
        <p className="rise" style={{ ...T.body, marginTop: 26, animationDelay: '750ms' }}>
          {a.signIn}
        </p>
        <div className="rise" style={{ marginTop: 44, animationDelay: '1000ms' }}>
          <PrimaryButton
            autoFocus
            onClick={onSignIn}
            testId={ctaTestId}
            icon={<MicrosoftMark size={17} color="var(--ink)" />}
          >
            Sign in with Microsoft
          </PrimaryButton>
        </div>
      </div>
    </ThresholdCanvas>
  )
}
